var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.266,
    height: 15.154,
    viewBox: "0 0 15.266 15.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16277",
    d: "m7.065 142.769-6.858-2.887a.149.149 0 0 0-.207.137v7.719a.477.477 0 0 0 .3.443l6.652 2.661a.149.149 0 0 0 .2-.138v-7.8a.149.149 0 0 0-.087-.135z",
    transform: "translate(0 -135.699)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16278",
    d: "M35.521 9.911 42.15 7.12a.149.149 0 0 0 .005-.272l-6.49-3.029a.477.477 0 0 0-.4 0l-6.49 3.029a.149.149 0 0 0 .005.272l6.629 2.791a.149.149 0 0 0 .112 0z",
    transform: "translate(-27.83 -3.662)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16279",
    d: "M272 142.906v7.8a.149.149 0 0 0 .2.138l6.652-2.661a.477.477 0 0 0 .3-.443v-7.719a.149.149 0 0 0-.207-.137l-6.858 2.888a.149.149 0 0 0-.087.134z",
    transform: "translate(-263.89 -135.699)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.ecc14ac8babeb534b4d3cc72fcbc8601.svg";
export { ForwardRef as ReactComponent };